import { styled } from '@mui/material';

export const Footer = styled('footer')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: 'var(--spacing-medium)',
  justifyContent: 'flex-end',
  paddingBlock: 'calc(var(--spacing-small) + var(--spacing-medium))',
  paddingInline: 'calc(var(--spacing-large) + var(--spacing-small))',
}));
